<template>
  <!-- <div @click="CallTestHaveCallBack"> -->
  <div class="h-screen overflow-y-auto">
    <div class="my-9">
      <div class="select-box">
        <DeviceSearchSelect placeholder="請選擇機台" @change="handleChange" />
      </div>
    </div>
    |
    <div v-if="deviceName" class="container_box">
      <div class="tabs">
        <span v-for="(item, index) of fileTypeNameArr" :key="index">
          <input v-model="program" type="radio" :id="'radio-' + index" name="tabs" checked @change="handleTabChange(index)" />
          <label :class="{ active: program === item }" class="tab" :for="'radio-' + index">{{ item }}</label>
        </span>
        <span ref="glider" :class="{ glider: program !== null }" class="" :style="{ transform: 'translateX(' + gliderPosition + '%)' }"></span>
      </div>
    </div>
    <div class="data-box">
      <tree-view class="tree-view" :data="jsonData" :options="{ maxDepth: 3 }"></tree-view>
    </div>
    <div v-if="deviceName" class=" flex justify-center">
      <a-button @click="DownloadJson()" type="primary" icon="download"> 下載此設定檔 </a-button>
    </div>
  </div>
</template>

<script>
import DeviceSearchSelect from '@/components/DeviceSearchSelect.vue'
export default {
  name: 'CheckProperties',

  data () {
    return {
      loading: false,
      mac: null,
      fileTypeNameArr: [],
      gliderPosition: 0, // Initial glider position
      program: null,
      deviceName: null,
      jsonData: {},
      fordata: {
        Version: '1.0.0',
        UpdateFolder: 'C:\\Users\\PARK\\Shopee\\update',
        HeartBeatPeriod: 30,
        AfterLaunchDelay: 30,
        ScanInfo: {
          name: '蝦皮繳費機',
          model: '2代機',
          serial: '00101',
          category: 0
        },
        PropertiesFilter: ['supervisory', 'cshm', 'paymentKiosk', 'kioskFrontend'],
        HeartBeatFilter: ['supervisory', 'ups', 'paymentKiosk', 'kioskFrontend'],
        KioskMqttBroker: {
          host: 'localhost',
          port: 1883,
          timeout: 60
        },
        ServerMqttBroker: {
          host: '192.168.128.251',
          port: 1883,
          timeout: 60
        },
        ParktronServer: {
          host: '192.168.128.144',
          port: 9527,
          updateApi: '/update/getCodeData'
        },
        Log: {
          level: 1,
          rollbackSize: 2,
          rollbackCount: 5,
          fileMode: 'a',
          fileName: './log/supervisory.log'
        },
        LogFolder: {
          cshm: 'C:\\Users\\PARK\\Shopee\\cshm\\log',
          kioskBackend: 'C:\\Users\\PARK\\Shopee\\kioskBackend\\logs',
          kioskFrontend: 'C:\\Users\\PARK\\Shopee\\kioskFrontend\\logs',
          payingCash: 'C:\\Users\\PARK\\Shopee\\Parktron.Blocks.Paying.Cash.Application\\log',
          ioModule: 'C:\\Users\\PARK\\Shopee\\Parktron.Blocks.IO.Application\\log'
        },
        ClearFile: [
          {
            path: 'C:\\Users\\PARK\\Shopee\\kioskBackend\\receipts\\abnormal',
            extType: 'pdf',
            keepDay: 90
          },
          {
            path: 'C:\\Users\\PARK\\Shopee\\kioskBackend\\receipts\\collect',
            extType: 'pdf',
            keepDay: 90
          },
          {
            path: 'C:\\Users\\PARK\\Shopee\\kioskBackend\\receipts\\complement',
            extType: 'pdf',
            keepDay: 90
          },
          {
            path: 'C:\\Users\\PARK\\Shopee\\kioskBackend\\receipts\\deposit',
            extType: 'pdf',
            keepDay: 90
          },
          {
            path: 'C:\\Users\\PARK\\Shopee\\cshm\\receipts',
            extType: 'pdf',
            keepDay: 90
          }
        ]
      }
    }
  },
  components: {
    DeviceSearchSelect
  },
  computed: {
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    },
    propertiesData: {
      get () {
        return this.$store.state.propertiesData
      },
      set () {}
    }
  },
  mounted () {},
  watch: {
    propertiesData: {
      handler (newValue, oldValue) {
        this.fileTypeNameArr = Object.keys(newValue)
        // this.program = this.fileTypeNameArr[0]
      },
      deep: true // 深度監聽 可以聽到物件裡的值改變
    }
  },
  methods: {
    DownloadJson () {
      const dataStr = JSON.stringify(this.jsonData, null, 2) // 格式化 JSON 数据
      const blob = new Blob([dataStr], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = this.deviceName + '-' + this.program
      link.download = fileName.endsWith('.json') ? fileName : `${fileName}.json` // 设置文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url) // 释放 URL 对象
    },
    handleTabChange (index) {
      this.program = this.fileTypeNameArr[index]
      this.gliderPosition = index * 100 // Set glider position based on index
      // console.log(this.program)
      this.jsonData = this.propertiesData[this.program]
    },
    handleChange (mac, selectedDevice) {
      this.deviceName = selectedDevice ? selectedDevice.device_name : null
      this.jsonData = {}

      if (!mac) {
        this.program = null
        this.fileTypeNameArr = []
        return
      }

      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${mac}/properties`
      this.mqttClient.send(message)
      setTimeout(() => {
        this.handleTabChange(0)
      }, 500)
    }
  }
}
</script>

<style lang="css" scoped>
.data-box {
  /* border: 1px solid; */
  display: flex;
  /* align-items: center; */
  justify-content: center;
  height: 500px;
  width: 700px;
  margin: 40px auto;
}
.ant-select {
  font-size: 20px;
  line-height: 1.5;
}

.select-box {
  width: 300px;
  margin: 0 auto;
}

.container_box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabs {
  display: flex;
  background-color: #fff;
  box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
  padding: 0.75rem;
  border-radius: 99px;
}

.tabs * {
  z-index: 2;
}

input[type="radio"] {
  display: none;
}

.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 150px;
  font-size: 1.25rem;
  font-weight: 500;
  border-radius: 99px;
  cursor: pointer;
  transition: color 0.15s ease-in;
}

.active {
  color: whitesmoke;
}
.glider {
  position: absolute;
  display: flex;
  height: 44px;
  width: 150px;
  background-color: rgb(85, 85, 161);
  z-index: 1;
  border-radius: 99px;
  transition: 0.25s ease-out;
}

.tree-view::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: rgba(125, 119, 102, 0.313);
  border-radius: 15px;
}
.tree-view::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(49, 186, 236, 0.7);
}

.tree-view {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  /* border: 1px solid black; */
}
</style>
